import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'DraggableWrapper',
  props: {
    renderData: {
      type: [Function, Object]
    }
  },
  setup(__props) {
    const props = __props;
    const handleDragStart = event => {
      if (!event.dataTransfer) return;
      // 在拖拽开始时，确定最终要发送的数据
      const finalData = typeof props.renderData === 'function' ? props.renderData() : props.renderData;
      // eslint-disable-next-line no-param-reassign
      event.dataTransfer.effectAllowed = 'copy';
      // 序列化后传递
      event.dataTransfer.setData('application/preview-data', JSON.stringify(finalData));
      // 可选：设置拖拽时的预览图（透明度等）
      // eslint-disable-next-line no-param-reassign
      event.dataTransfer.dropEffect = 'copy';
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        draggable: "true",
        class: "draggable-item",
        onDragstart: handleDragStart
      }, [_renderSlot(_ctx.$slots, "default")], 32);
    };
  }
});